import React, { useState } from 'react'
import { Form, Button, Card, Col } from 'react-bootstrap'
import { createUserWithEmailAndPassword } from "firebase/auth";

import { useNavigate } from "react-router-dom";
import { db, auth } from '../index';
import { ref, push, set, update } from "firebase/database";

import { Page } from '../components/Page';
import { map } from '@firebase/util';

function Signup(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [affil, setAffil] = useState("");
  const [classYear, setClassYear] = useState("");
  const [validated, setValidated] = useState(false);
  const nav = useNavigate();

  const start = 1950;
  const end = 2030;
  let classes = [...Array(end - start + 1).keys()].map(x => x + start);
  classes.reverse();

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      createUserWithEmailAndPassword(auth, email, password).then(() => {
        const key = auth.currentUser.uid;
        let newPref = {
          affiliation: affil,
          classYear: classYear
        };
        const updates = {};
        updates['/user-preferences/' + key] = newPref;
        update(ref(db), updates).catch((error) => {
          console.log(error);
        });
      }).then(() => {
        nav("/login");
      }).catch((error) => { console.log(error) });
    }
    setValidated(true);
  }

  return (
    <Page>
      <Col md={5}>
        <Card>
          <Card.Body>
            <Card.Title className='text-center'>Sign Up</Card.Title>
            <hr />
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control required type="email" placeholder="Enter email"
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control required type="password" placeholder="Password"
                  onChange={(e) => { setPassword(e.target.value) }}
                />
              </Form.Group>
              <Card.Title className='text-center mt-4'>Account Information</Card.Title>
              <hr />
              <Form.Group>
                <Form.Select required className='mb-3' onChange={(e) => { setAffil(e.target.value) }}>
                  <option value="">Select your affiliation</option>
                  <option value="UCLA Sorority">UCLA Sorority</option>
                  <option value="UCLA Fraternity">UCLA Fraternity</option>
                  <option value="UCLA Student">UCLA Student (not affiliated with Greek life)</option>
                  <option value="Non-UCLA Sorority">Non-UCLA Sorority</option>
                  <option value="Non-UCLA Fraternity">Non-UCLA Fraternity</option>
                  <option value="Non-UCLA Student">Non-UCLA Student (not affiliated with Greek life)</option>
                </Form.Select>
              </Form.Group>
              <Form.Select required className='mb-3' onChange={(e) => { setClassYear(e.target.value) }}>
                <option value="">Select your class year</option>
                {classes.map((x) => (
                  <option value={x}>{x}</option>
                ))}
              </Form.Select>
              <Button variant="primary" type="submit">Sign Up</Button>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Page>
  );
}

export { Signup }
